"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListAttributionEventResponseSchema = exports.ListAttributionEventQuerySchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
exports.ListAttributionEventQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({
    ...core_1.DateFilterFields,
    campaignId: typebox_1.Type.Optional(typebox_1.Type.Array(core_1.IdSchema)),
    country: typebox_1.Type.Optional(typebox_1.Type.Array(core_1.CountrySchema)),
    token: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.AttributionEventTokenSchema)),
    keyword: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.AttributionEventKeywordSchema)),
});
exports.ListAttributionEventResponseSchema = (0, core_1.createUnsortedListResponseSchema)(ruby_1.AttributionEventSchema);
